import { Convention } from '../../../concepts/objects';
import { Rect } from '../../../platform/geom/Rect';
import { Physical, RelativeTo } from '../../canvas/entities/Physical';

export type AutoLayoutMode = string[];

export const AutoLayoutMode = Object.freeze({
    none: ['none'] as AutoLayoutMode,
});

export interface AutoLayout extends Physical {

    readonly layoutMode: AutoLayoutMode;

    layoutCells(to?: RelativeTo): Rect[];
}

export const AutoLayout = new Convention<AutoLayout>('AutoLayout');

export interface AutoLayoutSubject extends Physical { }

export const AutoLayoutSubject = new Convention<AutoLayoutSubject>('AutoLayoutSubject');
